export class Days {
  static List: any[] = [
    { id: 1, code: '01' },
    { id: 2, code: '02' },
    { id: 3, code: '03' },
    { id: 4, code: '04' },
    { id: 5, code: '05' },
    { id: 6, code: '06' },
    { id: 7, code: '07' },
    { id: 8, code: '08' },
    { id: 9, code: '09' },
    { id: 10, code: '10' },
    { id: 11, code: '11' },
    { id: 12, code: '12' },
    { id: 13, code: '13' },
    { id: 14, code: '14' },
    { id: 15, code: '15' },
    { id: 16, code: '16' },
    { id: 17, code: '17' },
    { id: 18, code: '18' },
    { id: 19, code: '19' },
    { id: 20, code: '20' },
    { id: 21, code: '21' },
    { id: 22, code: '22' },
    { id: 23, code: '23' },
    { id: 24, code: '24' },
    { id: 25, code: '25' },
    { id: 26, code: '26' },
    { id: 27, code: '27' },
    { id: 28, code: '28' },
    { id: 29, code: '20' },
    { id: 30, code: '30' },
    { id: 31, code: '31' },
  ];
  // Méthode pour trouver un jour par son code
  static findByCode(code: string): any | undefined {
    return this.List.find((day) => day.code === code);
  }
}
